import { render, staticRenderFns } from "./multipleChannels.vue?vue&type=template&id=044f2d91&"
import script from "./multipleChannels.vue?vue&type=script&lang=js&"
export * from "./multipleChannels.vue?vue&type=script&lang=js&"
import style0 from "./multipleChannels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports